import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Observable } from "rxjs";
import { ActualitesService } from "../../services/actualites.service";
import { LogementService } from "../../services/logement.service";
import { Actualite } from "../../models/actualite";

@Component({
    selector: 'app-actualites',
    templateUrl: './actualites.component.html',
    styleUrls: ['./actualites.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ActualitesComponent implements OnInit {

  actualites$: Observable<Actualite[]>;

  constructor(private logementService: LogementService, private actualiteService: ActualitesService) {
  }

  ngOnInit() {
    const logementId = this.logementService.getLogementCourantId();
    this.actualites$ = this.actualiteService.load(logementId);
  }

}
